import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

function refreshToken(error) {
  const res = error.response.data;
  const refresh_token = localStorage.getItem("refresh_token");
  if (res.status === 400 || res.status === 401) {
    const body = {
      refresh_token: refresh_token
    };
    return axios
      .post("/v1/auth/refresh-token", body)
      .then(res => {
        JwtService.saveToken(res.data.data.access_token);
        document.location.reload(true);
      })
      .catch(error => {
        throw new Error(`[RWV] ApiService ${error}`);
      });
  }
}

const ApiService = {
  init(option) {
    Vue.use(VueAxios, axios);
    //console.log(API_URL, option);
    if (option == "heroku") {
      axios.defaults.baseURL = process.env.VUE_APP_URL;
    } else if (option == "customer") {
      axios.defaults.baseURL = process.env.VUE_APP_URL_CUSTOMER;
    } else {
      axios.defaults.baseURL = API_URL;
    }
  },
  setHeader() {
    axios.defaults.headers.common = {
      "Content-Type": "application/json",
      "x-token-api": "asf",
      Authorization: `${JwtService.getToken()}`
    };
    // axios.defaults.headers.common["Content-Type"] =
    //   "application/x-www-form-urlencoded";
  },
  query(resource, params) {
    return axios.get(resource, params).catch(error => {
      refreshToken(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
  get(resource, slug = "") {
    return axios.get(`${resource}/${slug}`).catch(error => {
      refreshToken(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
  post(resource, params) {
    return axios.post(`${resource}`, params);
  },
  update(resource, slug, params) {
    return axios.put(`${resource}/${slug}`, params);
  },
  put(resource, params) {
    return axios.put(`${resource}`, params);
  },
  delete(resource, params) {
    return axios.delete(resource, { data: params }).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
